import React from 'react';
import {
    Select,
    TextField,
    Stack
} from '@shopify/polaris';
import { SelectFilterTypes } from '../common/Helpers';

const tagsOperatorOptions = [
    { label: 'has tag', value: 'EqualTo' },
    { label: 'does not have tag', value: 'NotEqualTo' },
    { label: 'contains', value: 'Contains' },
    { label: 'does not contain', value: 'DoesNotContain' },
    { label: 'starts with', value: 'StartsWith' },
    { label: 'does not start with', value: 'DoesNotStartWith' },
    { label: 'ends with', value: 'EndsWith' },
    { label: 'does not end with', value: 'DoesNotEndWith' },
];

class ProductTagsFilterComponent extends React.Component {

    state = {};

    render() {

        let valueSelector = <TextField
            placeholder="Choose value"
            value={this.props.filter.value}
            onChange={(selected, id) => this.onValueChange(selected)}
        />;

        if (this.props.filter.operator === "EqualTo" || this.props.filter.operator === "NotEqualTo") {

            valueSelector = <Select
                placeholder="some tag"
                options={this.props.tags}
                value={this.props.filter.value}
                onChange={(selected, id) => this.onValueChange(selected)}
            />
        }

        return (
            <Stack alignment="center" spacing="tight">
                <Select
                    options={SelectFilterTypes}
                    value={this.props.filter.filterType}
                    onChange={(selected, id) => this.onFilterTypeChange(selected)}
                />
                <Select
                    options={tagsOperatorOptions}
                    value={this.props.filter.operator}
                    onChange={(selected, id) => this.onOperatorChange(selected)}
                />
                {valueSelector}
            </Stack>
        );
    }

    onFilterTypeChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.filterType = newValue;

        this.props.onFilterUpdated(newFilter);
    }

    onOperatorChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.operator = newValue;

        this.props.onFilterUpdated(newFilter);
    }

    onValueChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.value = newValue;

        this.props.onFilterUpdated(newFilter);
    }
}

export default ProductTagsFilterComponent;
